/**
 * context.ts — API client for Project Context endpoints (WEB-307 Context C5 FE).
 *
 * GET    /projects/:projectId/context          — get context profile (null if not analyzed)
 * POST   /projects/:projectId/context/analyze  — run AI analysis (PRO only; FREE → 403)
 * PATCH  /projects/:projectId/context          — manual field edits (overlay-as-manual)
 */
// Use the '@/api/client' alias (not './client') so the jest moduleNameMapper
// mock applies in tests; Vite resolves the alias to the real client in builds.
import { api } from '@/api/client';
import { longRequest } from '@/api/requestTimeout';
import type { ProjectContext } from '@/types/context';

export interface AnalyzeContextPayload {
  sourceUrl?: string;
  attempt: number;
  forceReanalyze?: boolean;
}

// WEB-667: превью бренд-контекста по ссылке для визарда (бесплатный скрейп, Pro-only,
// без projectId и без списаний). Глубокий платный AI остаётся фоном после создания.
export interface AnalyzePreviewPayload {
  sourceUrl: string;
  orgId?: string;
}

export interface AnalyzePreviewResult {
  name: string;
  category: string;
  iconUrl: string | null;
}

export const contextApi = {
  get: (projectId: string) =>
    api.get<{ context: ProjectContext | null }>(`/projects/${projectId}/context`),

  analyzePreview: (payload: AnalyzePreviewPayload) =>
    api.post<AnalyzePreviewResult>('/context/analyze-preview', payload),

  // WEB-3990: chargedCredits — сколько кредитов списал этот разбор (строка
  // долга не входит). Необязательное: старый сервер на время выката его не шлёт.
  analyze: (projectId: string, payload: AnalyzeContextPayload) =>
    api.post<{ context: ProjectContext; chargedCredits?: number }>(
      `/projects/${projectId}/context/analyze`,
      payload,
      longRequest('contextAnalyze'),
    ),

  patch: (projectId: string, partialContext: Partial<ProjectContext>) =>
    api.patch<{ context: ProjectContext }>(
      `/projects/${projectId}/context`,
      partialContext,
    ),
};
